import React from 'react';

import { useTranslation } from '@webtrader/core/i18n';

import ValidationError from '@/components/FormValidationError';
import TextInput from '@/components/TextInput';

import { StyledLoginFormField } from '../styled';

interface ILoginOtpFormEmailInputProps {
  value?: string;
  isError?: boolean;
  onEmailChange?: (value?: string) => void;
}

const LoginOtpFormEmailInput: FCC<ILoginOtpFormEmailInputProps> = (props) => {
  const { value, isError = false, onEmailChange } = props;
  const { t } = useTranslation();

  return (
    <StyledLoginFormField>
      <TextInput label={t('Email')} keyboardType="email-address" value={value} onChangeText={onEmailChange} />
      <ValidationError showValidation={isError} message={t('Email format is invalid')} />
    </StyledLoginFormField>
  );
};

export default LoginOtpFormEmailInput;
